import React, { useEffect, useRef, useState } from "react";
import axios from "axios";

export default function TextEditorToSection({ userDetail }) {

  const [formData, setFormData] = useState({
    mainLogo: "",
    secondaryLogo: "",
    defaultHeaderImage: "",
  });

  const [phone, setPhone] = useState();
  const [companyemail, setCompanyemail] = useState();
  const [fname, setFname] = useState();
  const [lname, setLname] = useState();
  const [companyname, setcompanyname] = useState();


  useEffect(() => {
    // If user detail is passed as prop (e.g. from shared contract response), use it directly
    if (userDetail) {
      setFormData({
        mainLogo: userDetail.Main_Logo ? process.env.REACT_APP_BACKEND_URL + userDetail.Main_Logo : null,
        secondaryLogo: userDetail.Secondary_Logo ? process.env.REACT_APP_BACKEND_URL + userDetail.Secondary_Logo : null,
        defaultHeaderImage: userDetail.Header_Images ? process.env.REACT_APP_BACKEND_URL + userDetail.Header_Images : null,
      });
      setPhone(userDetail.Phone_Number);
      setCompanyemail(userDetail.Company_Email);
      setFname(userDetail.first_name);
      setLname(userDetail.last_name);
      setcompanyname(userDetail.companyname);
      return;
    }

    const fetchuserdata = async () => {
      try {
        let userId = null;

        const storedUser = localStorage.getItem('user');
        if (storedUser) {
          try {
            const parsedUser = JSON.parse(storedUser);
            userId = parsedUser?.user?.id;
          } catch (e) {
            console.error("Invalid user JSON in localStorage", e);
          }
        }
        // Fallback to shared_user_id if main user is not found
        if (!userId) {
          userId = localStorage.getItem('shared_user_id');
        }
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/userdetaila/${userId}`);

        const userDetails = response.data.usersdetails?.[0];
        if (userDetails) {
          setFormData({
            mainLogo: userDetails.Main_Logo ? process.env.REACT_APP_BACKEND_URL + userDetails.Main_Logo : null,
            secondaryLogo: userDetails.Secondary_Logo ? process.env.REACT_APP_BACKEND_URL + userDetails.Secondary_Logo : null,
            defaultHeaderImage: userDetails.Header_Images ? process.env.REACT_APP_BACKEND_URL + userDetails.Header_Images : null,
          });

          setPhone(userDetails.Phone_Number);
          setCompanyemail(userDetails.Company_Email);

          setFname(userDetails.first_name);
          setLname(userDetails.last_name);
          setcompanyname(userDetails.companyname);
        }


      } catch (error) {
        console.error('Error fetching contract:', error);
      }
    };
    fetchuserdata();


  }, [userDetail]);







  return (
    <div className='editor_top_section position-relative' style={{ border: "none" }}>
      <div className='row text-center editor_top_section_content pt-5' style={{ border: "none" }}>
        <div className="row" style={formData.defaultHeaderImage ? {
          backgroundImage:
            `url('${formData.defaultHeaderImage}')`,
          height: "70vh",
          marginTop: "-48px",
          fontSize: "50px",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          marginLeft: "0px"
        } : {}} >
          <div className='col-md-4'>
            <div className='header'>&nbsp;</div>
          </div>
          <div className='col-md-4 d-flex justify-content-center'>
            {formData.mainLogo ? (
              <>
                <div className='Logo'>
                  <img
                    src={`${formData.mainLogo}?t=${new Date().getSeconds()}`}
                    alt="Main Logo Preview"
                    className="mainimgpath"
                  />

                </div>
              </>
            ) : (<>

            </>)}


          </div>
          <div className='col-md-4'>
            <div className='image'>&nbsp;</div>
          </div>
        </div>
       <div className='col-12 text-center mb-5 mt-4'>
  <h5 className='mb-2'>{companyname}</h5>
  
  
  
  <div style={{ wordBreak: 'break-word', whiteSpace: 'normal' }}> {fname} {lname}
    {phone ? <>| {phone} </> : ''} 
    {companyemail ? <>| {companyemail}</> : ''}
  </div>
</div>

        <hr className='m-0' />
        <div className='text-start note top-note'>
          <p>
            {/*  The contract is ready for review and signature. If you have any
            questions, just ask! */}
          </p>
        </div>
      </div>
    </div>
  );
}
